'use client';

import NavSearch from 'builder/components/elements/NavSearch';
import { SearchBarVariant } from 'builder/components/elements/NavSearchElements/searchUtils';
import { useRouter } from 'next/navigation';
import { type JSX, useState } from 'react';
import { getSearchUrl, SearchFilterContentTypes, type SearchOrigins } from 'search-gateway-client';

interface TopNavSearchBarProps {
    onCollapse?: () => void;
    showCloseButton?: boolean;
}

export default function TopNavSearchBar({ onCollapse, showCloseButton }: TopNavSearchBarProps): JSX.Element {
    const router = useRouter();
    const [showSuggestions, setShowSuggestions] = useState(false);

    const handleSubmit = (
        contentType: SearchFilterContentTypes,
        searchValue: string,
        searchOrigin: SearchOrigins,
    ): void => {
        const searchUrl = getSearchUrl({
            contentType,
            searchTerm: searchValue,
            searchOrigin,
        });
        router.push(searchUrl);
    };

    return (
        <NavSearch
            contentType={SearchFilterContentTypes.All_videos_content_type}
            onSubmit={handleSubmit}
            userHasAnySubscription={false}
            isEnterpriseMember={false}
            pproPluginEnabled={false}
            isSearchAppLoaded={(): boolean => true}
            imagesUrl=""
            showSuggestions={showSuggestions}
            setShowSuggestions={setShowSuggestions}
            searchBarVariant={SearchBarVariant.TopNav}
            className="lg:w-full"
            compact
            onCollapse={onCollapse}
            showCloseButton={showCloseButton}
        />
    );
}
